// src/components/Header.jsx
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import Container from "@mui/material/Container";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import ManageAccountsRoundedIcon from "@mui/icons-material/ManageAccountsRounded";
import { useAuth } from "react-oidc-context";
import "../styles/Header.scss";
import authConfig from '../authConfig';

const Header = () => {
  const auth = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Local state for version badge
  const [version, setVersion] = useState("");

  // Pull email from the OIDC user profile
  const email = auth.user?.profile?.email ?? "";

  // Menu anchor
  const [anchorElUser, setAnchorElUser] = useState(null);

  const settings = [
    { name: "Logout", action: "logout" },
  ];

  useEffect(() => {
    // Load version.txt for display
    fetch("/version.txt")
      .then((r) => r.text())
      .then((v) => setVersion(v.trim()))
      .catch(console.error);
  }, []);

  const handleOpenUserMenu = (e) => {
    setAnchorElUser(e.currentTarget);
  };
  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleUserMenuItemClick = (e) => {
    const settingName = e.currentTarget.getAttribute("data-setting");
    setAnchorElUser(null);

    if (settingName === "Logout") {
      // Redirect to the IdP's end-session endpoint
      signOutRedirect();
    }
  };

  // Only render header when logged in
  if (!auth.isAuthenticated) {
    return null;
  }



  const signOutRedirect = async () => {
    await auth.removeUser();
    window.location.href = `${authConfig.cogDomain}/logout?client_id=${authConfig.generalConf.client_id}&logout_uri=${encodeURIComponent(
      authConfig.generalConf.post_logout_redirect_uri
    )}`;
  };

  return (
    <div className="header-container">
      <AppBar className="appbar" position="static">
        <Container maxWidth="xxl">
          <Toolbar disableGutters className="toolb" sx={{ position: "relative" }}>
            <div />

            {location.pathname !== "/upload" && (
              <>
                <Box
                  className="header-appbarMenu"
                  sx={{
                    position: "absolute",
                    left: "50%",
                    transform: "translateX(-50%)",
                  }}
                >
                  <span className="headerTitle">CSM KPI Dashboard</span>
                </Box>

                <Box
                  sx={{
                    position: "absolute",
                    top: "10px",
                    right: "-6px",
                    zIndex: 99,
                    flexGrow: 0,
                  }}
                >
                  <Tooltip title="Open settings">
                    <IconButton onClick={handleOpenUserMenu} sx={{ ml: 1 }}>
                      <ManageAccountsRoundedIcon className="accnt-icn" />
                    </IconButton>
                  </Tooltip>
                  <Menu
                    sx={{ mt: "35px", ml: "10px" }}
                    anchorEl={anchorElUser}
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    keepMounted
                    transformOrigin={{ vertical: "top", horizontal: "right" }}
                    open={Boolean(anchorElUser)}
                    onClose={handleCloseUserMenu}
                  >
                    <MenuItem className="appbarMenuItem" disabled>
                      <Typography textAlign="center">{email}</Typography>
                    </MenuItem>
                    <MenuItem className="appbarMenuItem" disabled>
                      <Typography sx={{ fontSize: "0.7em" }} textAlign="center">
                        App version: {version}
                      </Typography>
                    </MenuItem>
                    <Divider />
                    {settings.map((setting) => (
                      <MenuItem
                        key={setting.name}
                        data-setting={setting.name}
                        onClick={handleUserMenuItemClick}
                      >
                        <Typography textAlign="center">{setting.name}</Typography>
                      </MenuItem>
                    ))}
                  </Menu>
                </Box>
              </>
            )}
          </Toolbar>
        </Container>
      </AppBar>
    </div>
  );
};

export default Header;
